import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IInventoryTemplatePresetRepository } from '@/coreInfrastructureModule/interfaces/IInventoryTemplatePresetRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryTemplatePreset, IInventoryTemplatePresetUpsertRequest } from '../domains/entities/InventoryTemplate';
import { InventoryTemplatePresetAdapter } from '../adapters/InventoryTemplatePresetAdapter';

/**
 * 出力条件プリセットを更新するユースケース
 */
export class UpdateInventoryTemplatePresetUseCase {
  /**
   * コンストラクタ
   * @param repository - 出力条件プリセットを更新するリポジトリ
   */
  constructor(private readonly repository: IInventoryTemplatePresetRepository) {}

  /**
   * プリセットを更新する
   * @param presetId - プリセットID
   * @param request - 更新内容
   */
  public Execute = async (
    presetId: string,
    request: IInventoryTemplatePresetUpsertRequest
  ): Promise<INetworkResult<IInventoryTemplatePreset, IError>> => {
    const result = await this.repository.update(presetId, InventoryTemplatePresetAdapter.toApiUpsertRequest(request));
    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: InventoryTemplatePresetAdapter.toEntity(result.status.data.preset),
        },
      };
    }

    return { status: result.status };
  };
}
